import Link from "next/link";
import Image from "next/image";
import RelatedProductRow from "@/components/related_product_row"; 
import ProductResources from "@/components/product_resources"; 
import useProductResourceVisibility from '@/lib/hooks/use_product_resource_visibility'; 
import AppGallery from "@/components/AppGallery";
import stringifySearch from "@/lib/utils.js"
import ProductPageConfigurator from '@/components/product_page_configurator'
export default function ProductBottomSection({sku_part_query, product, resource_display, application_photo_placement, configurator_settings, config} ) {
  const {resourcesVisible, collectionsVisible, similarProductsVisible, inspirationVisible, configuratorVisible } = useProductResourceVisibility(product)
  return ( 
    <>
      {resourcesVisible && 
      <>
        <a id="lexcms-product-resources"></a>
        <section className="lexcms-product-section-container">
          <ProductResources  {...product} 
            config={{enable_asset_multiple_link_download_modal: config?.enable_asset_multiple_link_download_modal, 
                     enable_asset_multiple_link_copying_modal: config?.enable_asset_multiple_link_copying_modal} }
                    product={product} resource_display={resource_display} />
        </section>
      </>
      }

      {configuratorVisible &&
        <>
        <hr className="lexcms-section-divider"
            id="lexcms-configurator-section"
          >
        </hr>
          <ProductPageConfigurator sku_part_query={sku_part_query} 
                                   always_show_description={configurator_settings?.always_show_description}
                                   product={product} />
        </>
      }
      {inspirationVisible &&
        <>
          <hr className="lexcms-section-divider"
            id="lexcms-product-inspiration"
          ></hr>
          <div className="lexcms-product-inspiration-section">
            <section className="lexcms-product-section-container">
              <h3 className="lexcms-product-section-heading">Inspiration</h3>
              <div className="lexcms-product-inspiration-content">
                <AppGallery key={product.id} product={product} application_photo_placement={application_photo_placement} />
              </div>
            </section>
          </div>
        </>
      }
      {similarProductsVisible && 
        <>
          <hr
            className="lexcms-section-divider"
            id="lexcms-product-similar-products"
          ></hr>
          <div className="lexcms-product-similar-products-section">
            <RelatedProductRow collectionName={'Similar Products'} 
                               collection={product.similar_products.products}
                               collectionLink={ (<Link href={`/lex-cms/products/all?${stringifySearch(product.similar_products.criteria)}`}> 
                  <a>
                  <p className="lexcms-product-similar-collection-all-link"> View All Similar Products </p> 
                </a>
              </Link>)}

            />
          </div>
        </>
      }
      {collectionsVisible &&
        <>
          <hr
            className="lexcms-section-divider"
            id="lexcms-product-collections"
          ></hr>
        <div className="lexcms-product-collections-section">
          {product.collections?.map((collec, i) => {
            return (<RelatedProductRow key={i} 
              collection={collec.other_products}
              collectionLink={ (<Link href={`/lex-cms/collections/${collec.slug}`}> 
                <a>
                  <p className="lexcms-product-similar-collection-all-link"> View Entire <span>Collection</span> </p> 
                </a>
              </Link>)
              }
              collectionName={collec.name} />)
          })
          }
        </div>
        </>
      }
      
    </>
  )
}
